<template>
  <div class="contents" v-loading="loading">
    <div class="title flexB">
      <h2>비디오 학습 관리</h2>
    </div>

    <ul class="categories flexL box" v-if="categories.length > 0">
      <li
        :class="{ unselect: true, active: topic === '' }"
        @click="handleCategory('')"
      >
        전체 ({{ categoryTotal }})
      </li>
      <li
        :class="{ unselect: true, active: cat._id === topic }"
        @click="handleCategory(cat._id)"
        v-for="(cat, i) in categories"
        :key="i"
      >
        {{ cat._id }} ({{ cat.count }})
      </li>
    </ul>
    <div class="box one">
      <div class="flexB mb20">
        <div class="flex searchWrap">
          <input
            type="text"
            v-model="searchWord"
            placeholder="Search"
            @keyup.enter="search"
          />

          <button @click="search" class="searchIcon">
            <img src="@/assets/images/icon_svg/search.svg" alt="search" />
          </button>
          <button class="cancel line" @click="reset">Cancel</button>
        </div>

        <router-link
          class="btn basic"
          :to="
            topic
              ? { path: '/admin/video/register', query: { topic } }
              : '/admin/video/register'
          "
          >비디오 등록</router-link
        >
      </div>

      <table>
        <colgroup>
          <col style="width: 5%" />
          <col style="width: 6%" />
          <col style="width: 10%" />
          <col style="width: 10%" />
          <col style="width: 17%" />
          <col style="width: 17%" />
          <col style="width: 20%" />
          <col style="width: 15%" />
        </colgroup>
        <tr>
          <th>
            <el-checkbox
              v-model="checkAll"
              @change="handleCheckAllChange"
            ></el-checkbox>
            <button @click="deleteVideos" class="delete" v-if="ids.length > 0">
              삭제
            </button>
          </th>
          <th>번호</th>
          <th>토픽</th>
          <th>카테고리</th>
          <th>제목</th>
          <th>강조 텍스트</th>
          <th>힌트 텍스트</th>
          <th>등록일</th>
        </tr>
        <tr v-for="(data, i) in videoList" :key="i">
          <td>
            <el-checkbox
              v-model="ids"
              :label="data._id"
              class="no-label-checkbox"
              @change="handleIdsChange"
            ></el-checkbox>
          </td>
          <td>{{ total - ((currentPage - 1) * 20 + i) }}</td>
          <td>{{ data.topic }}</td>
          <td>{{ translateCategories(data.categories).join(", ") }}</td>
          <td>
            <router-link to @click.native="handleMove(data._id)">{{
              data.title
            }}</router-link>
          </td>
          <td>{{ data.hiddenText }}</td>
          <td>{{ data.hintText }}</td>

          <td>{{ moment(data.createdAt).format("YYYY.MM.DD HH:mm") }}</td>
        </tr>
      </table>
      <div class="pagination" v-if="videoList.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="20"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <NoData v-else />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  fetchVideoList,
  fetchvideoCategories,
  removeVideoAll,
} from "@/api/admin";
import { format } from "@/mixins/format";
import NoData from "@/components/contents/Nodata";
export default {
  mixins: [format],
  components: { NoData },
  name: "videoManage",
  data() {
    return {
      moment: moment,
      loading: false,
      searchWord: "",
      videoList: [],
      total: 0,
      currentPage: 1,
      isNodata: false,
      categoryTotal: 0,
      topic: "",
      categories: [],
      ids: [],
      checkAll: false,
    };
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "4");
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === "videoRegister" && from.query.page) {
        vm.currentPage = parseInt(from.query.page);
      } else if (to.query.page) {
        vm.currentPage = parseInt(to.query.page);
      } else {
        vm.currentPage = 1;
      }

      if (from.name === "videoRegister" && from.query.topic) {
        vm.topic = from.query.topic;
      } else if (to.query.topic) {
        vm.topic = to.query.topic;
      } else {
        vm.topic = "";
      }

      const currentQueryPage = to.query.page;
      const currentQueryTopic = to.query.topic;
      const newPage = String(vm.currentPage);
      const newTopic = vm.topic;

      const shouldReplace =
        currentQueryPage !== newPage || (currentQueryTopic || "") !== newTopic;

      if (shouldReplace) {
        const query = { page: newPage };
        if (newTopic) query.topic = newTopic;

        vm.$router.replace({
          name: "videoManage",
          query,
        });
      }

      vm.getVideoList();
    });
  },
  mounted() {
    this.loading = true;
    this.getCategories();
  },
  methods: {
    translateCategories(categories) {
      if (!Array.isArray(categories)) return [];

      const map = {
        WRITE: "쓰기",
        READ: "읽기",
        SPEAK: "말하기",
        LISTEN: "듣기",
      };

      // 말하기, 듣기 제외
      const excluded = ["SPEAK", "LISTEN"];

      return categories
        .filter((c) => !excluded.includes(c))
        .map((c) => map[c] || c);
    },

    getCategories() {
      fetchvideoCategories().then((res) => {
        if (res.data.status == 200) {
          this.categories = res.data.data;
          this.categoryTotal = res.data.totalCount;
        } else {
          let message = res.data.message;
          alert(message);
        }
      });
    },
    handleCategory(cat) {
      this.loading = true;
      this.currentPage = 1;
      this.topic = cat;

      let query = {
        page: this.currentPage,
      };
      if (this.topic) {
        query.topic = this.topic;
      }
      this.$router.push({
        name: "videoManage",
        query: query,
      });

      this.getVideoList();
    },
    customFormatter(date) {
      return moment(date).format("YYYY년 MM월 DD일");
    },

    deleteVideos() {
      let result = confirm("삭제 하시겠습니까?");
      if (!result) {
        return;
      }
      let data = {
        ids: this.ids,
      };
      removeVideoAll(data).then((res) => {
        if (res.data.status == 200) {
          alert("삭제 되었습니다.");
          this.reset();
          this.checkAll = false;
          this.ids = [];
        }
      });
    },
    handleCheckAllChange(val) {
      this.ids = val ? this.videoList.map((item) => item._id) : [];
    },
    handleIdsChange() {
      this.checkAll = this.ids.length == this.videoList.length;
    },
    handleMove(id) {
      let query = {
        id: id,
        page: this.currentPage,
      };
      if (this.topic) {
        query.topic = this.topic;
      }
      this.$router.push({
        name: "videoRegister",
        query: query,
      });
    },

    reset() {
      this.searchWord = "";
      this.videoList = [];
      this.total = 0;
      this.currentPage = 1;
      this.topic = "";
      this.handleCurrentChange(1);
    },
    search() {
      if (this.searchWord == "") {
        return alert("검색어를 입력해 주세요.");
      }
      this.getVideoList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      let query = {
        page: this.currentPage,
      };
      if (this.topic) {
        query.topic = this.topic;
      }
      this.$router.push({
        name: "videoManage",
        query: query,
      });
      this.getVideoList();
    },
    getVideoList() {
      let params = {
        page: this.currentPage,
        searchWord: this.searchWord,
        topic: this.topic,
      };
      fetchVideoList(params).then((res) => {
        if (res.data.status == 200) {
          this.videoList = res.data.data;
          this.total = res.data.total;
          this.isNodata = this.total == 0 ? true : false;
          this.loading = false;
        } else {
          let message = res.data.message;
          alert(message);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
a.line2.sample-link,
button.line2.sample-link {
  width: auto;
  padding: 0 12px !important;
  box-sizing: border-box;
  cursor: pointer;
  font-weight: 400;
}
::v-deep .no-label-checkbox span {
  vertical-align: middle;
  line-height: 40px;
}

::v-deep .no-label-checkbox .el-checkbox__label {
  display: none;
}
button.delete {
  width: unset;
  height: unset;
  background: unset;
  border: none;
  font-size: 12px;
  margin-bottom: 4px;
  color: #9aa7c1;
}
</style>
